export const categoryEmojis: Record<string, string> = {
  "Visibility Boost": "👀",
  "Sales Booster": "💰",
  "Trust Builder": "❤️",
  "More Enquiries": "📞",
  "Customer Understanding": "🧠",
  "Business Clarity": "🎯",
  "Content Creation": "✍️",
  "Marketing Strategy": "📈",
  "Customer Experience": "⭐",
  "AI Automation": "🤖",
  "Business System": "⚙️",
  "Time Saver": "⏰",
  "Quick Win": "🚀",
};
